import { useMemo } from 'react';

import { flightTypeToDutch } from '@/utils/flightTypeToDutch';
import { formatDateDMY, formatDateGetTime } from '@/utils/formatDate/formatDate';
import { getAirportCodeFromParentheses } from '@/utils/getAirportCode';

import { StyledListItem } from '../styles';

import type { Flight, FlightPlan } from '@/types/flights';

interface FlightInfoProps {
  flight: Flight;
  flightPlan: FlightPlan;
  amountOfTravelers: number;
}

export function FlightInfo({ flight, flightPlan, amountOfTravelers }: FlightInfoProps) {
  const departureCode = useMemo(
    () => getAirportCodeFromParentheses(flight.departureAirport),
    [flight.departureAirport],
  );
  const arrivalCode = useMemo(() => getAirportCodeFromParentheses(flight.arrivalAirport), [flight.arrivalAirport]);

  const formattedDuration = useMemo(() => {
    const hours = Math.floor(flight.duration / 60);
    const minutes = flight.duration % 60;
    return `${hours}h ${minutes}m`;
  }, [flight.duration]);

  return (
    <>
      <StyledListItem>
        {amountOfTravelers} flight tickets {flightTypeToDutch(flight.type)} {departureCode} - {arrivalCode}
      </StyledListItem>
      <ul>
        <StyledListItem $isDetail>Date: {formatDateDMY(flight.departureDateTime)}</StyledListItem>
        <StyledListItem $isDetail>Departure: {formatDateGetTime(flight.departureDateTime)}</StyledListItem>
        <StyledListItem $isDetail>Arrival: {formatDateGetTime(flight.arrivalDateTime)}</StyledListItem>
        <StyledListItem $isDetail>Duration: {formattedDuration}</StyledListItem>
        <StyledListItem $isDetail>Airline: {flight.supplier}</StyledListItem>
        {flightPlan.flightOptions?.map((option) => (
          <StyledListItem $isDetail key={option.listId}>
            {option.name} - {option.description}
          </StyledListItem>
        ))}
      </ul>
    </>
  );
}
